export default __webpack_public_path__ + "static/media/Banner.6032548a.png";